import { t } from 'ember-intl';
import Component from '@glimmer/component';
import Paginator from 'tio-ui/components/navigation';
import Table from 'tio-ui/components/table';
import TableRow from './company-forms-table/row';
import type { PslfForm } from 'tio-common/models/search';
import type { SearchModelWith } from 'tio-common/models/search';

import type Controller from 'tio-employee/controllers/authenticated/admin/pslf/forms';

interface PslfAdminCompanyFormsTableSignature {
  Args: {
    model: SearchModelWith<PslfForm>;
    controller: Controller;
  };
}

export default class PslfAdminCompanyFormsTableComponent extends Component<PslfAdminCompanyFormsTableSignature> {
  updateSortBy = (sort: string) => {
    this.args.controller.order = sort;
  };

  changePaginatorPage = (page: number) => {
    this.args.controller.page = page;
  };

  <template>
    {{! @glint-expect-error: ED types}}
    <Table data-test-forms-table @isLoading={{@controller.loading}}>
      <:thead as |options|>
        <options.tr>
          <options.th>{{t "partner.employee.payroll_id"}}</options.th>
          <options.th
            @sortField="borrower_name.keyword"
            @activeSortField={{@controller.order}}
            @onSort={{this.updateSortBy}}
            @sortFormat="suffix"
          >
            {{t "common.name"}}
          </options.th>
          <options.th>{{t "common.status"}}</options.th>
          <options.th>{{t "common.pslf.forms.approver"}}</options.th>
          <options.th
            @sortField="borrower_sign_date"
            @activeSortField={{@controller.order}}
            @onSort={{this.updateSortBy}}
            @sortFormat="suffix"
          >
            {{t "pslf.table.date_borrower_signed"}}
          </options.th>
          <options.th
            @sortField="employer_sign_date"
            @activeSortField={{@controller.order}}
            @onSort={{this.updateSortBy}}
            @sortFormat="suffix"
          >
            {{t "pslf.document_repo.date_employer_signed"}}
          </options.th>
          <options.th>{{t "pslf.document_repo.form_type_and_employer"}}</options.th>
          <options.th />
        </options.tr>
      </:thead>
      <:tbody as |options|>
        {{#each @model.items as |item|}}
          <TableRow
            data-test-form-row
            @model={{item}}
            @rowClass={{options.rowClass}}
            @cellClass={{options.cellClass}}
          />
        {{/each}}
      </:tbody>
      <:tfoot>
        <tr>
          <td class="text-right" colspan="8">
            <Paginator
              @totalItems={{@model.total}}
              @pageSize={{@controller.limit}}
              @currentPage={{@controller.page}}
              @onChange={{this.changePaginatorPage}}
            />
          </td>
        </tr>
      </:tfoot>
    </Table>
  </template>
}
